<template>
<div class="chapter">
<div class="inner_page">
<div class="aboutAuthorPage">
<a id="title12"></a>
<div class="p"><span><strong class="b">Helen Brooks</strong> lives in Northamptonshire, England, and is married with three children. As she is a committed Christian, busy housewife and mother, her spare time is at a premium but her hobbies include reading and walking her two energetic and very endearing young dogs. Her long-cherished aspiration to write became a reality when she put pen to paper on reaching the age of forty, and sent the result off to Harlequin Mills &amp; Boon.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459263314_ata01.vue?151e2ac4